function isObjectSpreadable(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export const parsePageProperties = (string) => {
  if (!string) {
    return {};
  }
  // Parse the JSON string into a JavaScript object
  try {
    const props = JSON.parse(string);
    if (isObjectSpreadable(props)) {
      return props;
    } else {
      return {};
    }
  } catch (e) {
    console.error('Failed to parse pageProperties:', e);
    return {};
  }
};

export const extractPageProperties = () => {
  const pagePropertiesTag = document.getElementById('pageProperties');
  if (pagePropertiesTag) {
    // Extract the raw JSON string from the textContent
    const jsonString = pagePropertiesTag.textContent;
    return parsePageProperties(jsonString);
  } else {
    return {};
  }
};
